import React from 'react'
import { useTranslation } from 'react-i18next'

import { useLegalLinksContext } from '@context/LegalLinksContext'
import { BaseModalType } from '@context/ModalsContext'

import { Link } from '@ui/components/Link'
import { Modal } from '@ui/components/Modal'

export const DynamicLeverageModal: BaseModalType = (props) => {
  const { close } = props
  const { t } = useTranslation()
  const { docLinks } = useLegalLinksContext()

  return (
    <Modal>
      <Modal.Header>{t('Trading Account.Dynamic Leverage')}</Modal.Header>
      <Modal.Body>
        <Modal.Body.Text>
          {t('Trading Account.Dynamic Leverage is a tool')}{' '}
          {docLinks?.dynamicLeverageInfo ? (
            <Link href={docLinks.dynamicLeverageInfo} target='_blank' rel='noreferrer'>
              {t('here')}
            </Link>
          ) : (
            t('here')
          )}
        </Modal.Body.Text>
      </Modal.Body>
      <Modal.Footer>
        <Modal.Footer.Secondary onClick={close}>{t('Got It')}</Modal.Footer.Secondary>
      </Modal.Footer>
    </Modal>
  )
}
